import { initializeApp } from 'firebase/app';
import { FIREBASE_API } from './config';

const APP = initializeApp(FIREBASE_API);

export default APP;
